import React, { FC } from 'react';
import MuiTabs, { TabsProps as MuiTabsProps, TabsTypeMap } from '@mui/material/Tabs';
import { BpDesignSystem } from '../../types';
import { mergeClassNames } from '../../utils/cssClassNameHelper';
import { TabVariant } from './common';
import { styled } from '../../styles';

export type TabsProps = BpDesignSystem.PropsWithChildren<
  Omit<MuiTabsProps, 'variant' | 'onChange'> & {
    muiType?: MuiTabsProps['variant'];
    /**
     * @default: nav
     */
    variant?: TabVariant;
    onChange?: TabsTypeMap['props']['onChange'];
  }
>;

export const Tabs: FC<TabsProps> = ({ children, muiType, variant = 'nav', className, dataTest, ...props }) => (
  <StyledMuiTabs
    {...props}
    variant={muiType}
    $muiType={muiType}
    $variant={variant}
    data-test={dataTest}
    value={props.value ?? false}
    className={mergeClassNames(className, { 'tab-variant': variant === 'tab', 'nav-variant': variant === 'nav' })}
  >
    {children}
  </StyledMuiTabs>
);

const StyledMuiTabs = styled(MuiTabs)<{ $muiType: TabsProps['muiType'] | undefined; $variant: TabVariant | undefined }>`
  .MuiTabs-flexContainer {
    flex-wrap: ${({ $muiType }) => (['scrollable', 'fullWidth'].includes($muiType ?? '') ? 'nowrap' : 'wrap')};
    gap: ${({ theme, $variant }) => ($variant === 'nav' ? theme.spacingSize.m : 0)};
    .MuiTab-root {
      ${({ $muiType }) => ($muiType === 'fullWidth' ? 'min-width: auto;' : '')};
    }

  }
`;
